import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {
  DatatableActionButton,
  DatatableEvent,
  DatatableHandler,
  DatatableHandlerSettings,
  IconType,
} from '../../../components/datatables/datatable/datatable/datatable.component';
import {DataTableRoutes} from 'src/app/constants/datatableUrls';
import {TenantService} from '../../../services/tenant.service';
import {SimpleModalService} from 'ngx-simple-modal';
import {ExamAddressesClient} from '../../../generated-client/generated-api-client';
import {ToastrService} from 'ngx-toastr';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {ConfirmReasonModalComponent} from "../../../components/modals/archive-confirm-modal/confirm-reason-modal.component";
import { PersistentDataService } from '../../../services/persistent-data.service';

@Component({
  selector: 'app-exam-address-list',
  templateUrl: './exam-address-list.component.html',
  styleUrls: ['./exam-address-list.component.sass'],
})
export class ExamAddressListComponent implements OnInit {
  private _dtActionButtonsFn: (data: any) => DatatableActionButton[] = data => {
    const id = data['id'];
    const isArchived = data['isArchived'];

    const editUrl = `/exam-addresses/${id}`;
    const editAction = new DatatableActionButton('edit', 'Vizsgahelyszín szerkesztése', 'edit', editUrl);
    const archiveAction = isArchived
      ? new DatatableActionButton('unArchive', 'Vizsga helyszín aktiválása', 'unarchive', undefined, IconType.Danger)
      : new DatatableActionButton('archive', 'Vizsga helyszín archiválása', 'archive', undefined, IconType.Success);

    return [editAction, archiveAction];
  };

  dtHandler?: DatatableHandler;
  dtSettings: DatatableHandlerSettings = DatatableHandler.getDefaultSettings();
  dtDataSourceUrl: string = DataTableRoutes.ExamAddressList;

  constructor(
    private _titleService: Title,
    private _router: Router,
    private _tenantService: TenantService,
    private _modalService: SimpleModalService,
    private _examAddressesClient: ExamAddressesClient,
    private _toastr: ToastrService,
    private _errorProcessorService: ErrorProcessorService,
    private _pDservice: PersistentDataService
  ) {
    this._titleService.setTitle('Vizsgahelyszínek');

    this.dtSettings.buttons = [
      {
        text: 'Új vizsgahelyszín',
        class: 'btn-primary text-white',
        url: '/exam-addresses/new',
      },
    ];
    this.dtSettings.actions = this._dtActionButtonsFn;
    this.dtSettings.pageSize = _pDservice.examAddressPageSize;
    this.dtSettings.searchString = _pDservice.examAddressSearchString;

    this.dtSettings.additionalRequestData = () => {
      if (this.dtHandler?.pageSize != null)
        _pDservice.examAddressPageSize = this.dtHandler?.pageSize
      if (this.dtHandler?.searchString != null)
        _pDservice.examAddressSearchString = this.dtHandler?.searchString
      return {
        tenantId: this._tenantService.activeTenantId,
      };
    };

    this._tenantService.tenantId.subscribe(tenantId => {
      this.dtHandler?.refresh();
    });
  }

  onDtInit(dtHandler: DatatableHandler): void {
    this.dtHandler = dtHandler;
    this.dtHandler.create();
  }

  ngOnInit(): void {}

  onDtAction(event: DatatableEvent) {
    if (event.actionId === 'archive') {
      this.archive(event.data['id']);
    }
    if (event.actionId === 'unArchive') {
      this.unArchive(event.data['id']);
    }
  }

  private archive(id: string): void {
    this._modalService
      .addModal(ConfirmReasonModalComponent, {
        title: 'Vizsga helyszín archiválása',
        message: 'Biztosan archiválni szeretné a kiválasztott vizsga helyszínt?',
        confirmText: 'Igen',
        confirmClass: 'btn-danger text-white',
      })
      .subscribe(result => {
        if (result) {
          this._examAddressesClient.archive(id, result.reason).subscribe(
            () => {
              this.dtHandler?.refresh();
              this._toastr.success('Sikeres archiválás');
            },
            error => this._errorProcessorService.processError(error, true)
          );
        }
      });
  }

  private unArchive(id: string): void {
    this._modalService
      .addModal(ConfirmReasonModalComponent, {
        title: 'Vizsga helyszín aktiválása',
        message: 'Biztosan aktiválni szeretné a kiválasztott vizsga helyszínt?',
        confirmText: 'Igen',
        confirmClass: 'btn-primary text-white',
      })
      .subscribe(result => {
        if (result) {
          this._examAddressesClient.unArchive(id, result.reason).subscribe(
            () => {
              this.dtHandler?.refresh();
              this._toastr.success('Sikeres aktiválás');
            },
            error => this._errorProcessorService.processError(error, true)
          );
        }
      });
  }
}
